<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<header>
    <mat-toolbar color="primary" class="header">
        <a mat-icon-button routerLink="">
            <mat-icon>home</mat-icon>
        </a>
        <span class="header-title" i18n>
            <a href='{{ee4eGitHubURL}}' target="_blank">
                Easy Experiments for Everyone
            </a>
        </span>
        <button mat-button [matMenuTriggerFor]="toolboxMenu" class="right-link" style="font-size: 20px;">
            <mat-icon>build</mat-icon> Toolbox
        </button>
        <mat-menu #toolboxMenu>
            <button mat-menu-item>
                <mat-icon>analytics</mat-icon>
                <span>Explore Input KPI</span>
            </button>
            <button mat-menu-item (click)="navigateToCovariatesAnalysis()">
                <mat-icon>fact_check</mat-icon>
                <span>Covariates Analysis</span>
            </button>
        </mat-menu>
    </mat-toolbar>
</header>